import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router-dom';
import { graphLayoutQueryOptions, entityDetailsQueryOptions } from './queries/queryOptions';

export interface ScadaLoaderData {
    graphDetails: any | null;
    entityDetails: any | null;
    assetId: string;
}

export const scadaLoader =
    (queryClient: QueryClient) =>
        async ({ request }: LoaderFunctionArgs): Promise<ScadaLoaderData> => {
            const url = new URL(request.url);
            const path = url.pathname.replace(/^\/|\/$/g, '');
            const pathSegments = path.split('/');
            const assetId = pathSegments[pathSegments.length - 1] || '';

            if (!assetId) {
                return {
                    graphDetails: null,
                    entityDetails: null,
                    assetId: '',
                };
            }
            const graphQuery = graphLayoutQueryOptions(assetId);
            const entityQuery = entityDetailsQueryOptions(assetId);

            const [graphDetails, entityDetails] = await Promise.all([
                queryClient.getQueryData(graphQuery.queryKey) ?? (await queryClient.fetchQuery(graphQuery)),
                queryClient.getQueryData(entityQuery.queryKey) ?? (await queryClient.fetchQuery(entityQuery)),
            ]);

            return {
                graphDetails,
                entityDetails,
                assetId,
            };
        };

export { graphLayoutQueryOptions, entityDetailsQueryOptions };

